import upload from '@assets/upload.svg';
import upload_disabled from '@assets/upload_disabled.svg';
import { Spinner } from '@atoms/Spinner';

export type DropzoneProps = {
  onClick: () => void;
  label?: string;
  icon?: string;
  loading?: boolean;
  disabled?: boolean;
};

interface DropzoneBodyProps {
  label?: string;
  icon?: string;
  disabled?: boolean;
}

const DropzoneBody: React.FC<DropzoneBodyProps> = ({
  label,
  icon,
  disabled,
}) => {
  const defaultLabel = disabled ? 'Max photo limit reached' : 'Upload photo';
  const defaultIcon = disabled ? upload_disabled : upload;
  return (
    <span className="upload-font mx-auto my-6 flex flex-col items-center justify-between gap-x-5">
      <img
        src={icon ?? defaultIcon}
        alt="dropzone"
        className={`${disabled ? 'text-text-disabled' : 'text-action-button'} p-2`}
      />
      <p
        className={`${disabled ? 'text-text-disabled' : 'text-action-button'} text-body font-semibold`}
      >
        {label ?? defaultLabel}
      </p>
    </span>
  );
};

export const Dropzone = ({
  onClick,
  label,
  icon,
  loading,
  disabled,
}: DropzoneProps) => {
  return (
    <button
      data-testid="dropzone"
      className={`mx-auto flex h-[167px] w-full items-center justify-between gap-x-5 rounded-xl border-2 border-dashed border-gray-400 sm:ml-0 sm:flex-grow md:h-[280px] md:w-[631px] lg:h-[300px] lg:w-[755px] ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={onClick}
      style={{ display: 'flex' }}
      disabled={disabled}
    >
      {loading ? (
        <div className="mx-auto">
          <Spinner />
        </div>
      ) : (
        <DropzoneBody icon={icon} label={label} disabled={disabled} />
      )}
    </button>
  );
};

Dropzone.displayName = 'Dropzone';
